import React, { Component } from "react";

export default class step1 extends Component {
  render() {
    return (
      <div className="step-container">
        <div className="subtitle">Step 4</div>
        <div className="step-name">
          Confirm your payment details <br /> and send your request
        </div>
      </div>
    );
  }
}
